import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { PromptField } from './PromptField';
import { TerminalButton } from './TerminalButton';

export const PasswordBox = (props: {
  onSubmit: (password: string) => void
  error?: string | null
}) => {
  const isMountedRef = useRef(true)
  const [password, setPassword] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPassword(event.target.value)
  }

  const handlePasswordKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handlePasswordSubmit()
    }
  }

  const handlePasswordSubmit = () => {
    setIsSubmitting(true)
    props.onSubmit(password)
    if (isMountedRef.current) {
      setIsSubmitting(false)
    }
  }

  useEffect(() => () => {isMountedRef.current = false}, [])

  return (
    <PasswordContainer>
      <PromptField
        label="password"
        type="password"
        autoFocus
        disabled={isSubmitting}
        error={!!props.error}
        helperText={props.error || " "}
        onKeyPress={handlePasswordKeyPress}
        onChange={handlePasswordChange}
        value={password}
      />
      <TerminalButton
        type="button"
        disabled={isSubmitting}
        onClick={handlePasswordSubmit}
      >
        access
      </TerminalButton>
    </PasswordContainer>
  )
}

const PasswordContainer = styled.div`
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
